import { Repo } from '../data/schema.js';

/**
 * 落盘系统：定期把玩家位置、朝向、游戏时长写回数据库。
 * 真正的磁盘写入由 Database.tick 节流完成。
 */
export const persistSystem = {
  name: 'persist',
  _acc: 0,
  update(dt, ctx) {
    this._acc += dt;
    if (this._acc < 2) return;
    this._acc = 0;

    const { scene, db } = ctx;
    const e = scene.first('transform', 'player');
    if (!e) return;
    const p = Repo.getPlayer(db);
    Repo.savePlayer(db, {
      x: Math.round(e.transform.x),
      y: Math.round(e.transform.y),
      facing: e.anim.facing,
      scene: scene.id,
      playtime: (p.playtime || 0) + 2,
    });
  },
};
